import React from 'react';

import AnalysisEbayResultsSection from './AnalysisEbayResultsSection';
import AnalysisImageGallery from './AnalysisImageGallery';
import AnalysisItemsList from './AnalysisItemsList';
import AnalysisResultMetaBadges from './AnalysisResultMetaBadges';
import AnalysisSummaryStats from './AnalysisSummaryStats';

const AnalysisResultsSection = ({
  analysisResult,
  modelName,
  useEbayRag,
  useNotesRag,
  assumeHiddenItems,
  analysisDisplayImageUrls,
  currentImageIndex,
  onChangeCurrentImageIndex,
  colors,
  onOpenModal,
  onMarkResultImageError,
  originalPrices,
  originalNames,
  updatingId,
  updatingNameId,
  onManualNameChange,
  onUpdateItemName,
  onPriceChange,
  onUpdatePrice,
  ebayLoading,
  ebayResults,
  isAdmin = false,
}) => {
  const items = Array.isArray(analysisResult?.items) ? analysisResult.items : [];

  return (
    <div className="mt-4 sm:mt-8">
      <h3 className="text-lg sm:text-xl font-semibold text-ink mb-2 sm:mb-3">Analysis Results:</h3>
      <div>
        {/* Run details (model / tokens / cost …) are internal — admins only */}
        {isAdmin && (
          <AnalysisResultMetaBadges
            analysisResult={analysisResult}
            modelName={modelName}
            useEbayRag={useEbayRag}
            useNotesRag={useNotesRag}
            assumeHiddenItems={assumeHiddenItems}
          />
        )}

        <div className="flex flex-col md:flex-row gap-4 sm:gap-6">
          <div className="w-full md:w-1/2 flex flex-col gap-4 sm:gap-6">
            <AnalysisSummaryStats items={items} />
            <AnalysisImageGallery
              analysisDisplayImageUrls={analysisDisplayImageUrls}
              currentImageIndex={currentImageIndex}
              onChangeCurrentImageIndex={onChangeCurrentImageIndex}
              items={items}
              colors={colors}
              onOpenModal={onOpenModal}
              onMarkResultImageError={onMarkResultImageError}
            />
          </div>
          <AnalysisItemsList
            items={items}
            currentImageIndex={currentImageIndex}
            originalPrices={originalPrices}
            originalNames={originalNames}
            updatingId={updatingId}
            updatingNameId={updatingNameId}
            onManualNameChange={onManualNameChange}
            onUpdateItemName={onUpdateItemName}
            onPriceChange={onPriceChange}
            onUpdatePrice={onUpdatePrice}
            isAdmin={isAdmin}
          />
        </div>

        <AnalysisEbayResultsSection
          ebayLoading={ebayLoading}
          ebayResults={ebayResults}
        />
      </div>
    </div>
  );
};

export default AnalysisResultsSection;
